import React, {useEffect, useMemo, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle, SelectField} from "@atttomyx/react-components";
import {forms} from "@atttomyx/shared-utils";
import {mergeFields} from "../../konstants";

const MergeFieldsDialog = (props) => {
    const { submissionMergeFields, onCancel, onInsert } = props;
    const [ object, setObject ] = useState(null);
    const [ field, setField ] = useState(null);

    const objects = useMemo(() => {
        const map = {};

        Object.entries(mergeFields).forEach(([key, value]) => {
            map[key] = value.label;
        });

        Object.entries(submissionMergeFields).forEach(([key, value]) => {
            map[key] = value.label;
        });

        return map;
    }, [submissionMergeFields]);

    const definition = useMemo(() => {
        return mergeFields[object];
    }, [object]);

    const submission = useMemo(() => {
        return submissionMergeFields[object];
    }, [object]);

    const fields = useMemo(() => {
        let map = null;

        if (definition) {
            map = definition.fields;

        } else if (submission) {
            map = submission.fields;
        }

        return map;
    }, [definition, submission]);

    const mergeField = useMemo(() => {
        return object && field
            ? submission
                ? `{{ submission.${object}.${field} }}`
                : `{{ ${object}.${field} }}`
            : null;
    }, [object, field, submission]);

    useEffect(() => {
        if (fields && field && !fields[field]) {
            setField(null);
        }
    }, [fields, field]);

    return <Dialog
        open={true}
        aria-labelledby="merge-fields-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Merge Fields
        </ClosableDialogTitle>
        <DialogContent className="merge-fields-dialog">
            <div className="field top-margin">
                <SelectField
                    label="Object"
                    value={forms.sanitizeValue(object)}
                    onChange={setObject}
                    options={objects}
                />
            </div>
            {fields ?
                <div className="field">
                    <SelectField
                        label="Field"
                        value={forms.sanitizeValue(field)}
                        onChange={setField}
                        options={fields}
                    />
                </div> : null}
        </DialogContent>
        <DialogActions>
            <Button color="primary"
                    disabled={!mergeField}
                    onClick={() => onInsert(mergeField)}>
                Insert
            </Button>
        </DialogActions>
    </Dialog>
}

export default MergeFieldsDialog;
